<template>
    <el-dialog
        :visible="dialogVisible"
        width="80%"
        @close="handleClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false">
        <slot name="component"></slot>
        <template #footer>
            <div>
                <el-button
                    type="primary"
                    @click="handleClose">
                    <span>{{$t("public.confirmBtn")}}</span>
                </el-button>
            </div>
			<div style="padding: 10px; display: flex;justify-content: flex-end;">
				<el-pagination
				  @current-change="handleCurrent"
				  :current-page.sync="currentPage2"
				  :page-size="page.per_page"
				  layout="prev, pager, next, jumper"
				  :total="page.total"
				  background>
				</el-pagination>
			</div>
        </template>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
    computed: mapState({
        dialogVisible: state => state.dialogVisible,
		page: state => state.user.page,
    }),
	data() {
		return {
			currentPage2:0,
		}
	},
	watch:{
		currentPage(){
			this.currentPage2 = this.currentPage
		}
	},
    methods: {
        ...mapMutations([
            "handleDialog",
            "setAnalysis",
			"getAnalysis"
        ]),
		
		handleCurrent(current){
		    this.$emit('goPpages', current)
		},
        handleClose(){
            this.handleDialog(false);
            this.setAnalysis([]);
        }
    },
}
</script>

<style scoped>

</style>